import { TriangleAlert } from 'lucide-react';
import { tr } from '../../lib/i18n.ts';

/** Shown next to data that could not be refreshed; an icon and text, so it never relies on colour. */
export function StaleMark() {
  return (
    <span className="iw-stale" title={tr.infobar.stale}>
      <TriangleAlert size={12} aria-hidden />
      <span className="visually-hidden">{tr.infobar.stale}</span>
    </span>
  );
}
